/*====================================
    重設企業用戶密碼的 controller

    Author : Gray
    最後更新時間 : 2017 / 05 / 25
====================================*/
window.InifECMobileApp.controller('ResetBusinessMemberPasswordController', ['$scope', '$rootScope', '$stateParams',
    function($scope, $rootScope, $stateParams) {

        var init = function() {
            
            $rootScope.$broadcast('OPEN_RESET_BUSINESS_PW_MODAL', {
                email: $scope.email,
                token: $scope.token
            });
        }

        /*==========================
          Members
        ==========================*/
        $scope.email = $stateParams.email;
        $scope.token = $stateParams.token;

        /*==========================
          init
        ==========================*/
        init();
    }
])
